export function isNullOrUndefined<T>(object: T | null | undefined): object is null | undefined {
  return object === null || object === undefined;
}
